
export default {
  props: {
    label: { type: String, required: true },
    value: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    required: { type: Boolean, required: false, default: () => false },
    errorMessage: { type: String },
    name: { type: String, required: true },
  },
  data() {
    return {
      showError: false,
      error: undefined,
    };
  },
  computed: {
    inputName() {
      return this.label.toLowerCase();
    },
    inputId() {
      return `forminput-${this.label.toLowerCase().replace(" ", "-")}`;
    },
  },
  methods: {
    onBlur(e) {
      if (
        this.required &&
        (e.target.value === "" || e.target.value === undefined)
      ) {
        this.error = this.errorMessage;
        this.showError = true;
      } else {
        this.showError = false;
      }
    },
  },
};
